var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-plans-wrap"},_vm._l((_vm.plans),function(plan,i){return _c('campaign-plan-card',{key:plan.id,staticClass:"mb-5",attrs:{"campaign-plan":plan},on:{"change":function($event){return _vm.updateItem($event, i)},"add":_vm.addNewPlan,"remove":_vm.removePlan}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }